export const DATE_FORMAT_SHORT = 'dd.MM.yy';
export const DATE_FORMAT_LONG = 'dd.MM.yyyy';
export const DATE_FORMAT_LONG_REVERSE = 'YYYY-MM-DD';
export const DATE_FORMAT_FULL = 'dd.MM.yyyy HH:mm:ss';
export const DATE_FORMAT_LONG_MINUTE = 'dd.MM.yyyy HH:mm';
export const SYSTEM_DATE_FORMAT = 'yyyy-MM-dd';
export const TIME_FORMAT = 'HH:mm';
export const DATE_FORMAT_ISO = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
export const DATE_FORMAT_ISO_FNS = "yyyy-MM-dd'T'HH:mm:ss.SSS";
export const DATE_FORMAT_LONG_MINUTE_FNS = 'dd.MM.yyyy HH:mm';
